import {Routes} from '@angular/router';

export const CONTENT_ROUTES: Routes = [
    {
        path: 'checkprice',
        loadChildren:
            './modules/checkprice/availibility/availibility.module#AvailibilityModule'
    },
    {
        path: 'checkprice',
        loadChildren:
            './modules/checkprice/recap/recap.module#RecapModule'
    },
    {
      path: 'checkprice',
      loadChildren:
        './modules/checkprice/achats/achats.module#AchatsModule'
    },
    {
        path: 'checkprice',
        loadChildren:
            './modules/checkprice/viewresa/view-resa.module#ViewResaModule'
    },
    {
        path: 'dashboard',
        loadChildren: './modules/home/home.module#HomeModule'
    },
    {
        path: 'about',
        loadChildren: './modules/about/about.module#AboutModule'
    },
    {
        path: 'contact',
        loadChildren: './modules/contact/contact.module#ContactModule'
    }
];
